/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-nested-conditional */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useTranslation } from 'react-i18next';

const SurveillanceComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.surveillance_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Surveillance Type</th>
            <td>{t(`surveillance.${report.surveillance_type.toLowerCase()}`)}</td>
          </tr>
          {report.person_approach && (
            <tr>
              <th>Person Approach</th>
              <td>{t(`surveillance.${report.person_approach.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.surveillance_type === 'person' && report.person && (
            <tr className="!border-none">
              <th>Person</th>
            </tr>
          )}
          {report.surveillance_type === 'person' && report.person && (
            <tr>
              <td className="!float-none">
                <table className="!mt-0">
                  <tbody>
                    {report.person.age && (
                      <tr>
                        <th>Age</th>
                        <td>{report.person.age}</td>
                      </tr>
                    )}
                    {report.person.build && (
                      <tr>
                        <th>Build</th>
                        <td>{report.person.build}</td>
                      </tr>
                    )}
                    {report.person.colour && (
                      <tr>
                        <th>Colour</th>
                        <td>{report.person.colour}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.birthmarks ||
                      report.person.distinguishing_features?.birthmarks === '') && (
                      <tr>
                        <th>Birthmarks</th>
                        <td>{report.person.distinguishing_features.birthmarks || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.clothing ||
                      report.person.distinguishing_features?.clothing === '') && (
                      <tr>
                        <th>Clothing</th>
                        <td>{report.person.distinguishing_features.clothing || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.muscular ||
                      report.person.distinguishing_features?.muscular === '') && (
                      <tr>
                        <th>Muscular</th>
                        <td>{report.person.distinguishing_features.muscular || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.piercings ||
                      report.person.distinguishing_features?.piercings === '') && (
                      <tr>
                        <th>Piercings</th>
                        <td>{report.person.distinguishing_features.piercings || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.scars ||
                      report.person.distinguishing_features?.scars === '') && (
                      <tr>
                        <th>Scars</th>
                        <td>{report.person.distinguishing_features.scars || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.distinguishing_features?.tattoos ||
                      report.person.distinguishing_features?.tattoos === '') && (
                      <tr>
                        <th>Tattoos</th>
                        <td>{report.person.distinguishing_features.tattoos || 'Yes'}</td>
                      </tr>
                    )}
                    {report.person.elevation && (
                      <tr>
                        <th>Elevation</th>
                        <td>{report.person.elevation}</td>
                      </tr>
                    )}
                    {report.person.face?.teeth && (
                      <tr>
                        <th>Teeth</th>
                        <td>{report.person.face.teeth}</td>
                      </tr>
                    )}
                    {report.person.face?.eyes && (
                      <tr>
                        <th>Eyes</th>
                        <td>{report.person.face.eyes}</td>
                      </tr>
                    )}
                    {(report.person.face?.facial_hair ||
                      report.person.face?.facial_hair === '') && (
                      <tr>
                        <th>Facial Hair</th>
                        <td>{report.person.face.facial_hair || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.person.face?.round ||
                      report.person.face?.round === '' ||
                      report.person.face?.square ||
                      report.person.face?.square === '' ||
                      report.person.face?.narrow ||
                      report.person.face?.narrow === '') && (
                      <tr>
                        <th>Face shape</th>
                        <td>
                          {report.person.face?.round || report.person.face?.round === ''
                            ? 'Round'
                            : report.person.face?.square || report.person.face?.square === ''
                              ? 'Square'
                              : 'Narrow'}
                        </td>
                      </tr>
                    )}
                    {report.person.gender && (
                      <tr>
                        <th>Gender</th>
                        <td>{report.person.gender}</td>
                      </tr>
                    )}
                    {report.person.hair_colour && (
                      <tr>
                        <th>Hair Colour</th>
                        <td>{report.person.hair_colour}</td>
                      </tr>
                    )}
                    {report.person.hair_length && (
                      <tr>
                        <th>Hair Length</th>
                        <td>{report.person.hair_length}</td>
                      </tr>
                    )}
                    {report.person.hair_texture && (
                      <tr>
                        <th>Hair Texture</th>
                        <td>{report.person.hair_texture}</td>
                      </tr>
                    )}
                    {/* {report.person.gait && (
                      <tr>
                        <th>Gait</th>
                        <td>{report.person.gait}</td>
                      </tr>
                    )} */}
                    {report.person.additional_details && (
                      <tr>
                        <th className="text-left w-full">Additional Details</th>
                        <td className="!pt-0 w-full pb-[20px]">
                          {report.person.additional_details}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
          {report.surveillance_type === 'vehicle' && report.vehicle && (
            <tr>
              <th>Vehicle Approach</th>
              <td>{t(`surveillance.${report.vehicle_approach.toLowerCase()}`)}</td>
            </tr>
          )}
          {report.surveillance_type === 'vehicle' && report.vehicle && (
            <tr className="!border-none">
              <th>Vehicle</th>
            </tr>
          )}
          {report.surveillance_type === 'vehicle' && report.vehicle && (
            <tr>
              <td className="!float-none">
                <table className="!mt-0">
                  <tbody>
                    {report.vehicle.shape && (
                      <tr>
                        <th>Shape</th>
                        <td>{report.vehicle.shape}</td>
                      </tr>
                    )}
                    {report.vehicle.colour && (
                      <tr>
                        <th>Colour</th>
                        <td>{report.vehicle.colour}</td>
                      </tr>
                    )}
                    {report.vehicle.registration && (
                      <tr>
                        <th>Registration</th>
                        <td>{report.vehicle.registration}</td>
                      </tr>
                    )}
                    {(report.vehicle.identifying_features?.bodywork ||
                      report.vehicle.identifying_features?.bodywork === '') && (
                      <tr>
                        <th>Bodywork</th>
                        <td>{report.vehicle.identifying_features.bodywork || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.vehicle.identifying_features?.dents ||
                      report.vehicle.identifying_features?.dents === '') && (
                      <tr>
                        <th>Dents</th>
                        <td>{report.vehicle.identifying_features.dents || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.vehicle.identifying_features?.scratches ||
                      report.vehicle.identifying_features?.scratches === '') && (
                      <tr>
                        <th>Scratches</th>
                        <td>{report.vehicle.identifying_features.scratches || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.vehicle.identifying_features?.spoilers ||
                      report.vehicle.identifying_features?.spoilers === '') && (
                      <tr>
                        <th>Spoilers</th>
                        <td>{report.vehicle.identifying_features.spoilers || 'Yes'}</td>
                      </tr>
                    )}
                    {(report.vehicle.identifying_features?.tints ||
                      report.vehicle.identifying_features?.tints === '') && (
                      <tr>
                        <th>Tints</th>
                        <td>{report.vehicle.identifying_features.tints || 'Yes'}</td>
                      </tr>
                    )}
                    {report.vehicle.make_model && (
                      <tr>
                        <th>Make/Model</th>
                        <td>{report.vehicle.make_model}</td>
                      </tr>
                    )}
                    {report.vehicle.additional_details && (
                      <tr>
                        <th className="text-left w-full">Additional Details</th>
                        <td className="!pt-0 w-full !pb-[20px]">
                          {report.vehicle.additional_details}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SurveillanceComponent;
